export enum CssUrl {
  inline = 'inline',
  none = 'none',
}
